import type { VariableTextEditorVariable } from '@super/node-graph-ui'
import {
  BASE_VARIABLES,
  AVAILABLE_VARIABLES,
} from '@/features/agent-detail/agent-detail.constants'

/**
 * Variables the form-node item editor offers in `{{` autocomplete. Mirrors
 * the v2 agent-settings picker so the author sees one consistent list across
 * surfaces. Agent-scoped base vars first, then the shared lead-level set that
 * is widely available on inbound and outbound calls.
 */
export const AVAILABLE_VARIABLES_FOR_EDITOR: readonly VariableTextEditorVariable[] =
  AVAILABLE_VARIABLES.filter(
    v => v.scope === 'SHARED' || BASE_VARIABLES.some(b => b.name === v.name),
  ).map(({ scope: _scope, ...rest }) => rest)
